$(document).ready(function (){

  $(document).on('click', '.scroll-target', function (event){
    let targetId = $(this).attr('href');
    if(targetId.indexOf('#') == 0) {
      event.preventDefault();
      let offset = $(targetId).offset().top - $('#shopify-section-header').height();
      $('html, body').animate({ scrollTop: offset }, 750);
    }
  });

  $('iframe').each(function (){
    if ($(this).parents().is('.rte')) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });
  
  $(document).on('click', '.download-image', function(event) {
    event.preventDefault();
    var href = $(this).attr('href');
    var name = $(this).data('name');
    saveAs(href, name);
  });

  $(document).on('click', '.size-guid-chart', function() {
    $('.main-size-guid-chart').css('display', 'block');
    $('.product__info-container').addClass('popup-active');
    $('body').css('overflow-y', 'hidden');
  });

   $(document).on('click', '.main-size-guid-chart .popup-close', function() {
    $('.main-size-guid-chart').css('display', 'none');
    $('.product__info-container').removeClass('popup-active');
    $('body').css('overflow-y', 'scroll');
  });

  $(document).mouseup(function (event) {
    var container =  $('.popup-content');
    if (!container.is(event.target) && container.has(event.target).length === 0 && $('.popup-content')) {
      $('.main-size-guid-chart').css('display', 'none');
      $('.product__info-container').removeClass('popup-active');
      $('body').css('overflow-y', 'scroll');
    }   
  });

  $(document).keyup(function(e) {
     if (e.key === "Escape") {
       $('.main-size-guid-chart').css('display', 'none');
       $('.product__info-container').removeClass('popup-active');
       $('body').css('overflow-y', 'scroll');
    }
  });
  
});